import React, { Component } from 'react'
import { Link } from "react-router-dom"
import { Container, Card, Button } from 'react-bootstrap'
import web3 from '../ethereum/web3'
import Header from './Header'
import tokenSale from '../ethereum/tokenSale'


class TokenSale extends Component {
  constructor(props) {
    super(props)

    this.state = {
      price: '',
      tokenContract: '',
      tokensSold: ''
    }
  }

  async componentDidMount() {
    const { params } = this.props.match
    const tSale = tokenSale(params.id)

    const priceWei = await tSale.methods.price().call()
    const tokenContract = await tSale.methods.tokenContract().call()
    const tokensSold = await tSale.methods.tokensSold().call()

    const price = web3.utils.fromWei(priceWei, 'ether')

    this.setState({
      price,
      tokenContract,
      tokensSold
    })
  }

  render() {

    return (
      <Container>
        <Header />
        <Card className="text-center" border="success" style={{ marginTop: '35px' }}>
          <Card.Body>
            <Card.Title>Price: {this.state.price} ether per token</Card.Title>
            <Card.Title>
              Token Contract: {this.state.tokenContract}
            </Card.Title>
            <Card.Title>
              Tokens Sold: {this.state.tokensSold}
            </Card.Title>

            <div>
              <Link to={`/tokens/${this.state.tokenContract}`} ><Button href={`/ERC20Token-factory-and-market/tokens/${this.state.tokenContract}`} variant="outline-success" size="lg">Token Details</Button></Link>
              <Link to={`/buytoken/${this.props.match.params.id}`} ><Button href={`/ERC20Token-factory-and-market/buytoken/${this.props.match.params.id}`} variant="outline-success" size="lg">Buy Token</Button></Link>
            </div>

          </Card.Body>
        </Card>
      </Container>
    )
  }
}

export default TokenSale;
